import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum } from 'myParkdUtils/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faColumns } from '@fortawesome/free-solid-svg-icons';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import AppWrapper from 'components/board/AppWrapper';
import { ReduxState } from 'types';
import MainHeader from 'components/board/MainHeader';
import MainContent from 'components/board/MainContent';
import { companyUsersSliceActions } from 'features/users/companyUsersSlice';
import { USERS_TABLE_DEFAULT_COLUMN_VISIBILITY, USERS_TABLE_OPTIONAL_COLUMNS, usersTableColumns, usersTableDefaultSorting } from 'components/users/usersTableColumns';
import TableV8 from 'components/table/TableV8';
import { getMyParkdUserSettings } from 'features/settings/myParkdSettings';


export const UsersScreen = (props: Props) => {

    const { paging } = props;
    const { companyUsers, usersGetStatus } = props;
    const usersTableColumnSettings = { ...USERS_TABLE_DEFAULT_COLUMN_VISIBILITY, ...props?.myParkdUserSettings?.usersTableColumnSettings };

    return (
        <AppWrapper>
            <main id="page-users" className="col-main">
                <MainHeader>
                    <div className="header-v-align">
                        <h2 className="main-header-title">
                            <FormattedMessage id="MANAGE_USERS" /> ({companyUsers && paging.totalElements})
                        </h2>

                        <div className='header-action-buttons'>
                            <button className='btn-small-blue'
                                onClick={() => props.updateModal(ModalEnum.MANAGE_TABLE_COLUMNS, {
                                    tableSettingsName: 'usersTableColumnSettings',
                                    optionalColumns: USERS_TABLE_OPTIONAL_COLUMNS,
                                })}
                            >
                                <FontAwesomeIcon icon={faColumns} className='fa-icon' />
                                <FormattedMessage id="GLOBAL_MANAGE_COLUMNS" />
                            </button>
                        </div>
                    </div>
                </MainHeader>

                <MainContent>
                    <div className="board-content radius-rectangle no-overflow">
                        <TableV8
                            data={companyUsers}
                            status={usersGetStatus}
                            columns={usersTableColumns}
                            defaultSorting={usersTableDefaultSorting}
                            columnVisibility={usersTableColumnSettings}
                            pagination={paging}
                            fetchData={props.getCompanyUsers}
                        />
                    </div>
                </MainContent>
            </main>
        </AppWrapper>
    );
}


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & StateProps;

function mapStateToProps(state: ReduxState) {
    return {
        companyUsers: state.companyUsers.companyUsers,
        paging: state.companyUsers.paging,
        usersGetStatus: state.companyUsers.usersGetStatus,
        companyPublicId: state.companyDetails?.companyDetails?.publicId,
        myParkdUserSettings: getMyParkdUserSettings(state)
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        getCompanyUsers: companyUsersSliceActions.getCompanyUsers,
        updateModal: modalWindowActions.updateModalWindow,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersScreen);